import { UserType } from "../data/User";
import { apiRequest } from "./apiService";

export async function getAuth (login: string, senha: string) {
    const response = await apiRequest<UserType>('/login', 'POST', true, { login, senha });
    
    if(response) {        
        localStorage.setItem('user', JSON.stringify(response));
        return response;
    }

    return null;
}

export function logoutAuth() {
    // Opcional: Chamar um endpoint no backend para invalidar o token/sessão do lado do servidor.
    // try {
    //   await apiRequest('/logout', 'POST', true);
    // } catch (error) {
    //   console.error("Falha ao realizar logout no servidor:", error);
    //   // Mesmo com falha no servidor, o logout no cliente deve prosseguir.
    // }

    // Remove os dados do usuário do localStorage para deslogar no cliente.
    localStorage.removeItem('user');
}